import { getUrlParamByName } from '@/utils/app';

window.addEventListener('load', () => {
    const sectionToScroll = getUrlParamByName('scrollTo');
    if (sectionToScroll) {
        (window as any).Scroller.scrollTo(`#${sectionToScroll}`, 0);
    }
});
